export const CHAINS_PER_MILE = 80;
export const YARDS_PER_CHAIN = 22;
export const METRES_PER_CHAIN = 20.1186;

export const formatLineReference = (route_id, subposition, position) => {
    let yards = Math.floor((position - Math.floor(position / CHAINS_PER_MILE) * CHAINS_PER_MILE) * YARDS_PER_CHAIN);
    return `${route_id} ${Math.floor(position / CHAINS_PER_MILE)}m ${yards}y ${subposition}`;
};
